import { MutableRefObject } from 'react';

import { MediaBreakpoint } from 'craft/types';

import {
  SET_DOCUMENT_DOM,
  SET_SCROLLABLE_BODY_DOM,
  SET_TOOLBOX_STATE,
  SET_VIEWPORT_BREAKPOINT,
  SET_VIEWPORT_CONTAINER_DOM,
  SET_VIEWPORT_CONTENT_DOM,
  SET_VIEWPORT_WRAPPER_DOM,
} from './constants';

export const setToolboxState = (isDocked: boolean) => ({
  type: SET_TOOLBOX_STATE,
  isDocked,
});

export const setViewportBreakpoint = (breakpoint: MediaBreakpoint) => ({
  type: SET_VIEWPORT_BREAKPOINT,
  breakpoint,
});

export const setViewportWrapperDom = (
  viewportWrapperRef: MutableRefObject<HTMLElement | null>,
) => ({
  type: SET_VIEWPORT_WRAPPER_DOM,
  viewportWrapperRef,
});

export const setViewportContainerDom = (
  viewportContainerRef: MutableRefObject<HTMLElement | null>,
) => ({
  type: SET_VIEWPORT_CONTAINER_DOM,
  viewportContainerRef,
});

export const setViewportContentDom = (
  viewportContentRef: MutableRefObject<HTMLElement | null>,
) => ({
  type: SET_VIEWPORT_CONTENT_DOM,
  viewportContentRef,
});

export const setDocumentDom = (documentRef: MutableRefObject<HTMLElement | null>) => ({
  type: SET_DOCUMENT_DOM,
  documentRef,
});

export const setScrollableBodyDom = (scrollableBodyRef: MutableRefObject<HTMLElement | null>) => ({
  type: SET_SCROLLABLE_BODY_DOM,
  scrollableBodyRef,
});
